import { Movement } from "../Movement";
import { MovementTabs } from "../MovementTabs";
import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutMovementTabView extends Layout {
    layoutMovement: Movement;
    layoutMovementTabs: MovementTabs;
}
